import { EXCLUDE_RIBBON_PREFIXES, SAP_OFFERT_STORAGE_KEY } from '@/data/config/SAPOFFERT';
import { Ribbon } from '@/data/types/Product';

export const isExcludeRibbon = (identifier: string) =>
	EXCLUDE_RIBBON_PREFIXES.some((ribbon) => identifier.startsWith(ribbon));

export const mergeRibbonsForProduct = (ribbons: Ribbon[]) => {
	const sapOferta = ribbons.filter((item) => item.identifier === SAP_OFFERT_STORAGE_KEY);
	const otherRibbons = ribbons.filter((item) => !isExcludeRibbon(item.identifier));
	const sortedRibbons = [...sapOferta, ...otherRibbons];

	const uniqueRibbons = sortedRibbons.filter(
		(ribbon, index, self) => index === self.findIndex((t) => t.value === ribbon.value)
	);

	return uniqueRibbons;
};
